import React from "react";
import Clientele1 from "../../Assets/homeimgs/Clientele1.png";
import Clientele2 from "../../Assets/homeimgs/Clientele2.png";
import Clientele3 from "../../Assets/homeimgs/Clientele3.png";
import Clientele4 from "../../Assets/homeimgs/Clientele4.png";
import Clientele5 from "../../Assets/homeimgs/Clientele5.png";
import Clientele6 from "../../Assets/homeimgs/Clientele6.png";
import Clientele7 from "../../Assets/homeimgs/Clientele7.png";
import Clientele8 from "../../Assets/homeimgs/Clientele8.png";
import Clientele9 from "../../Assets/homeimgs/Clientele9.png";
import Clientele10 from "../../Assets/homeimgs/Clientele10.png";
import Clientele11 from "../../Assets/homeimgs/epil.png";
import Clientele12 from "../../Assets/homeimgs/nalco.png";
import Clientele13 from "../../Assets/homeimgs/omc.png";
import Clientele14 from "../../Assets/homeimgs/bridhe-and-bar.png";
import Clientele15 from "../../Assets/homeimgs/obcc.png";
import Clientele16 from "../../Assets/homeimgs/iprcl.png";

const OurClientele = () => {
  const clients = [
    { src: Clientele1, alt: "Client logo 1", aos: "fade-right" },
    { src: Clientele2, alt: "Client logo 2", aos: "flip-up" },
    { src: Clientele3, alt: "Client logo 3", aos: "zoom-in" },
    { src: Clientele4, alt: "Client logo 4", aos: "flip-down" },
    { src: Clientele5, alt: "Client logo 5", aos: "fade-left" },
    { src: Clientele6, alt: "Client logo 6", aos: "fade-right" },
    { src: Clientele7, alt: "Client logo 7", aos: "flip-up" },
    { src: Clientele8, alt: "Client logo 8", aos: "zoom-in" },
    { src: Clientele9, alt: "Client logo 9", aos: "flip-down" },
    { src: Clientele10, alt: "Client logo 10", aos: "flip-left" },
    { src: Clientele11, alt: "Client logo 11", aos: "fade-right" },
    { src: Clientele12, alt: "Client logo 12", aos: "flip-up" },
    { src: Clientele13, alt: "Client logo 13", aos: "zoom-in" },
    { src: Clientele14, alt: "Client logo 14", aos: "flip-down" },
    { src: Clientele15, alt: "Client logo 14", aos: "flip-left" },
    { src: Clientele16, alt: "Client logo 14", aos: "flip-right" },
  ];
  return (
    <React.Fragment>
      <div className="md:mx-16 mx-6 mt-8 md:mt-16">
        <div className="md:max-w-[70%] mx-auto">
          <h1 className="text-3xl lg:text-5xl font-semibold text-center mb-4">
            Our Clients
          </h1>
          <p className="text-gray-600 text-base md:text-md lg:text-xl">
            "Our client is a forward-thinking company dedicated to delivering
            innovative solutions. With a strong focus on quality, they
            consistently strive to exceed expectations and build long-lasting
            partnerships."
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 mt-8 md:mt-14">
          {clients.map((client, index) => (
            <div key={index}>
              <img
                src={client.src}
                alt={client.alt}
                className="mx-auto rounded-lg "
                data-aos={client.aos}
              />
            </div>
          ))}
        </div>
      </div>
    </React.Fragment>
  );
};

export default OurClientele;
